var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qcw-trigger-btn",style:(_vm.buttonStyle),on:{"click":_vm.clickHandler}},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e(),(_vm.label)?_c('div',[_vm._v(_vm._s((_vm.label)))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1895511a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QcwTrigger.vue
// module id = CpMU
// module chunks = 0